<template>
    <div>
        <el-carousel height="355px" indicator-position="none">
            <el-carousel-item v-for="item in imgs" :key="item.url">
                <img class="banner-img" :src="item.img" alt="" @click="goTo(item.url)">
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default {
    data() {
        return {
            imgs: [
                // {
                //     url: '',
                //     img: 'https://pic.rmb.bdstatic.com/bjh/8a4bd48cb5280f6bd8e18712e4f6f9e7.jpeg'
                // },
                // {
                //     url: '/recharge',
                //     img: require("@/index/assets/banner3.png")
                // },
                // {
                //     url: '/checkAccount',
                //     img: require("@/index/assets/banner2.png")
                // },
                {
                    url: '/agent-join',
                    img: require("@/index/assets/banner1.png")
                },
                // {
                //     url: '/flow/taobao',
                //     img: 'https://pic.rmb.bdstatic.com/bjh/ba13d1d9ee0f88b598399fae6c0b3826.png'
                // },
                // {
                //     url: '/checkNum/firstPause',
                //     img: 'https://pic.rmb.bdstatic.com/bjh/213c45f8cb72fc88cdded5f673e888d2.png'
                // },
                // {
                //     url: '/home',
                //     img: 'https://pic.rmb.bdstatic.com/bjh/65ec9c0dbde1266ed44f9be9426fec26.png'
                // }
            ]
        }
    },
    methods: {
        goTo(url) {
            if (!url) {
                return
            }
            if (url.indexOf("http") > -1) {
                window.open(url)
            } else {
                window.open(url)
                // this.$router.push(url)
            }
        },
    }
}
</script>

<style lang="scss" scoped>

</style>

<style>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .banner-img {
      width: 100%;
      height: 100%;
  }
</style>
